import {deliveryCost, freeDeliveryThreshold} from '@/store/delivery';
import {isFreeItem} from "@/mixins/free-item";
import {nf} from "@/utils/string";

/**
 * Полная цена товаров корзины: без недоступных в городе и без бесплатных позиций
 * (скидка 100%, напр. конфета за опрос), без учета скидки по купону/скидочной карте.
 * @param items корзина с проверенной доступностью (city.js: checkBasketItemsAvailability)
 */
export function itemsFullPrice(items) {
	return (items || []).reduce((sum, item) => {
		if (!item.isProductAvailable) return sum;
		if (!(item.AMOUNT > 0)) return sum;
		if (isFreeItem(item)) return sum;
		return sum + Number(item.PRICE) * Number(item.AMOUNT);
	}, 0);
}

/**
 * Стоимость доставки и сумма заказа для порога бесплатной доставки.
 *
 * Порог бесплатной доставки задается правилом работы с корзиной "Бесплатная доставка" в админке
 * (приходит с бэкенда вместе со стоимостью доставки, см. App.vue и \entities\Delivery).
 * Правило Битрикс сравнивает с порогом сумму корзины ДО скидки по карте/купону, вместе с открыткой
 * (она добавляется в корзину заказа) - так же считаем и здесь.
 *
 * Требует в компоненте: prop form, mixin city (checkBasketItemsAvailability).
 */
export default {
	computed: {
		orderSumForFreeDelivery() {
			const items = this.checkBasketItemsAvailability(this.$store.state.session?.basket);
			return itemsFullPrice(items) + (Number(this.form.POSTCARD_PRICE) || 0);
		},
		/**
		 * null - не определено!
		 * 0 - бесплатно!
		 * @returns {*}
		 */
		deliveryCost() {
			return deliveryCost(this.form, this.orderSumForFreeDelivery);
		},
		/**
		 * Состояние бесплатной доставки для мотивирующих сообщений:
		 * null - сообщения не нужны (зона не выбрана, самовывоз, для зоны нет порога, стоимость не определена);
		 * {isFree: true} - доставка уже бесплатная;
		 * {isFree: false, remaining} - сколько рублей не хватает до бесплатной доставки.
		 */
		freeDeliveryInfo() {
			const cost = this.deliveryCost;
			const threshold = freeDeliveryThreshold(this.form);
			if (cost === null || !threshold) return null;
			if (cost === 0) return {isFree: true};

			return {isFree: false, remaining: Math.ceil(threshold - this.orderSumForFreeDelivery)};
		},
		/**
		 * Части текста мотивирующего сообщения (см. freeDeliveryInfo) или null:
		 * ["Добавьте товаров ещё на X ₽", "для бесплатной доставки"] либо ["Доставка бесплатная"].
		 * Части разделены там, где при необходимости можно сделать перенос строки.
		 */
		freeDeliveryTextParts() {
			const info = this.freeDeliveryInfo;
			if (!info) return null;
			if (info.isFree) return ["Доставка бесплатная"];
			return ["Добавьте товаров ещё на " + nf(info.remaining) + " ₽", "для бесплатной доставки"];
		},
		/**
		 * Текст мотивирующего сообщения одной строкой или null.
		 */
		freeDeliveryText() {
			return this.freeDeliveryTextParts?.join(" ") || null;
		},
	},
}
